import { api } from '@services';
import Equipment, { IEquipment } from '@models/Equipment.model';

export interface ICreateEquipments {
  amountProducts: IProductAmount[];
}
export interface IProductAmount {
  productId?: string;
  tempProductName?: string;
  tempProductModel?: string;
  manufacturerId?: string;
  tempManufacturerName?: string;
  resource?: string;
  amount: number;
}

const createEquipments = async (
  data: ICreateEquipments,
): Promise<IEquipment[]> => {
  const { data: equipments } = await api.post(`/equipments/amount`, data);
  return Equipment.arrayFromApiModel(equipments);
};

export { createEquipments };
